import { useEffect } from 'react'
import PropTypes from 'prop-types'

const LockScroll = ({ locked, children = null }) => {
  useEffect(() => {
    const lockScroll = isLocked => {
      const bodyStyle = document.body.style
      const position = bodyStyle.top

      bodyStyle.width = isLocked ? '100%' : ''
      bodyStyle.height = isLocked ? '100%' : ''
      bodyStyle.overflow = isLocked ? 'hidden' : ''

      if (!isLocked && position) {
        document.documentElement.scrollTop = parseInt(position.replace('px'), 10) * -1
      }
    }

    lockScroll(locked)
    return () => lockScroll(false)
  }, [locked])

  return children
}

LockScroll.propTypes = {
  locked: PropTypes.bool.isRequired,
  children: PropTypes.node,
}

export default LockScroll
